<template>
    <BzDialog
        visible
        width="960px"
        :custom-class="`pz-save-to-workspace-dialog pz-save-to-workspace-dialog__${service.type}`"
        :before-close="() => service.onClose()"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        :title="$t(`BaseSaveToWorkspace.Main.title`)"
        v-bind="$attrs"
    >
        <slot>
            <SequenceSelector
                :sequence-name="service.selectedObj.seqName"
                :selected-count="service.selectedObj.selectedCount"
                @update-name="onUpdateName"
            />
        </slot>

        <FolderSelector />

        <template
            slot="footer"
        >
            <button
                class="pt-ui-btn"
                size="small"
                @click="service.onClose()"
            >
                {{ $t('BaseSaveToWorkspace.Main.cancel') }}
            </button>
            <button
                class="pt-ui-btn"
                size="small"
                type="primary"
                :data-dialog-type="service.type"
                :disabled="service.isSubmitButtonDisabled()"
                @click="service.onSubmit()"
            >
                <PtIcon
                    v-if="service.isSubmitting"
                    icon="SolidLoadingBars"
                    class="s2w-submit-loading-icon"
                />
                <template v-else>
                    {{ $t('BaseSaveToWorkspace.Main.submit') }}
                </template>
            </button>
        </template>
    </BzDialog>
</template>

<script>
import BzDialog from '@patsnap-biz/dialog';
import PtIcon from '@patsnap-biz/icon';
import FolderSelector from '../Basic/components/FolderSelector/FolderSelector.vue';
import SequenceSelector from './SequenceSelector.vue';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';

export default {
    name: 'SavePaperToWorkspaceDialog',
    components: {
        BzDialog,
        FolderSelector,
        PtIcon,
        SequenceSelector,
    },
    provide() {
        return {
            service: this.service,
        };
    },
    props: {
        service: {
            type: Object,
            required: true,
        },
    },
    methods: {
        onUpdateName(val) {
            this.service.updateSeqName(val);
        },
    },
};
</script>
